import React from 'react';
import { FiftyFifty } from '@layout';
import { Button } from '@input';
import styles from './Donate.module.scss';
import image from './image.jpg';

export default function Donate() {
  return (
    <FiftyFifty
      image={image}
      clipImage={false}
    >
      <div className={styles.content}>
        <h2>Our planet needs everyone’s imagination</h2>
        <p>
          Climate disruption, water scarcity, and loss of nature take
          something away from every human on the planet. Inclusive science
          helps solve these problems.
        </p>
        <p>
          We grow and nurture diverse leaders who solve environmental
          problems and create pathways to sustainability.
        </p>
        <Button
          href="https://giving.ucla.edu/campaign/donate.aspx?Fund=64061o"
          icon="heart"
        >
          Donate to The Center
        </Button>
      </div>
    </FiftyFifty>
  );
}
